<template>
  <div class="general-update-section">
    <h2 v-if="this.notes" class="ut-text-xl ut-font-bold general-title">General updates</h2>
    <div class="general-update-box ut-w-full">

      <div v-if="this.notes" class="general-update-msgs ut-w-full">
        <general-update-message
          v-for="update in this.notes"
          :key="update.id"
          :value="update.id"
          :name="formatName(update)"
          :message="update.note"
          :date="formatDate(update.createddate)" />
      </div>

      <div class="ut-mt-6 md:ut-flex md:ut-items-start md:ut-content-start">
        <div class="md:ut-w-1/2 md:ut-mr-2 ut-mt-0">
          <action-cards />
        </div>
        <div class="md:ut-w-1/2  md:ut-ml-2 ut-mt-0">
          <general-update-consultant-info
            v-if="lead.assignedconsultantkey"
            :name="lead.assignedconsultantname"
            v-bind:image="lead.assignedconsultantimageurl
              ? lead.assignedconsultantimageurl
              : require('@/assets/styles/frontend-library/images/user.svg')"
            :phone="lead.assignedconsultantphone"
            :email="lead.assignedconsultantemail" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex';
import GeneralUpdateConsultantInfo from '@/components/GeneralUpdateConsultantInfo.vue';
import GeneralUpdateMessage from '@/components/GeneralUpdateMessage.vue';
import ActionCards from '@/components/ActionCards.vue';
import StageUpdate from '@/mixins/StageUpdate';

export default {
  name: 'GeneralUpdate',
  components: {
    GeneralUpdateMessage,
    GeneralUpdateConsultantInfo,
    ActionCards,
  },
  mixins: [
    StageUpdate,
  ],
  props: {
    showMessage: {
      requried: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      notes: state => state.leadAgentMappingStore.notes,
      lead: state => state.leadAgentMappingStore.lead,
      agentExperiments: state => state.experimentStore.agentExperiments,
    }),
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
  },
  data() {
    return {
      disableSubmit: false,
      message: '',
    };
  },
  watch: {
    showMessage() {
      const el = this.$refs.msgInput;
      if (el) this.$nextTick(() => { el.focus(); });
    },
  },
  methods: {
    ...mapMutations('leadAgentMappingStore', [
      'setLeadAgentMapping',
      'pushNote',
    ]),
    formatDate(dateString) {
      return this.$options.filters.formatDate(dateString, 'D MMM YYYY hh:mma');
    },
    formatName(generalUpdate) {
      if (generalUpdate && generalUpdate.user && generalUpdate.user.firstname) {
        const firstname = generalUpdate.user.firstname;
        const lastname = generalUpdate.user.lastname;
        return `${firstname} ${lastname}`;
      }
      return this.lam.agentname;
    },
    createCaseForGeneralUpdate() {
      const caseData = {
        leadkey: this.lead.key,
        agentkey: this.$route.params.ak,
        // agentkey: this.agent.key,
        leadstatus: 'General Update',
        comment: this.message,
      };
      return this.$apiServices.oa.lead.createCaseForLeadUpdate(caseData);
    },
    submitGeneralUpdateMsg() {
      if (this.message !== '') {
        this.disableSubmit = true;
        this.saveGeneralUpdateMsg().then(() => {
          this.disableSubmit = false;
          this.message = '';
        });
      }
    },
    saveGeneralUpdateMsg() {
      const data = {
        leadid: this.lead.id,
        agentid: this.lam.agentid,
        // agentid: this.agent.id,
        notetypeid: 3,
        note: this.message,
        userkey: this.isLamOwner ? this.lam.agentuserkey : (this.$route.params.uk || ''),
        userroleid: this.isLamOwner ? 2 : 11,
      };
      return this.$noteService.create(data)
        .then((noteData) => {
          if (noteData) {
            this.createCaseForGeneralUpdate();
            this.pushNote(noteData);
            const updatedLam = this.lam;
            updatedLam.agentlastupdatedate = noteData.createddate;
            this.setLeadAgentMapping(updatedLam);
          }
        });
    },
  },
};

</script>

<style lang="scss" scoped>

.general-update-section {
  color: #000000;
  @apply ut-my-10 ut--mx-4;

  .general-title {
    @apply ut-ml-4;
    @screen md {
      @apply ut-ml-0;
    }
  }

  .general-update-box {
    @apply ut-my-4;

    @screen md {
      @apply ut-my-4;
    }
  }

  .general-update-msgs {
    background-color: #FFFFFF;
    background-color: #FFFFFF;
    box-shadow: 0 1px 4px 1px rgba(0,0,0,0.04);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 3px;
  }

  .general-update-new-msg {
    @apply ut-p-6;
    border-top: 1px solid #E3E5E8;

    .new-message-title {
      @apply ut-font-bold ut-mb-2;
    }

    .msg-input {
      border: 1px solid #D9D9D9;
      border-radius: 4px;
      @apply ut-flex;

      textarea {
        width: 94%;
        font-size: 14px;
        line-height: normal;
        @apply ut-pt-4 ut-pl-4;

        &:focus {
          outline: none !important;
        }

      }

      button {
      }

    }
  }
}
</style>
